enum ApiErrorCodes {
  AUTH_TOKEN_MISSING = 'AUTH_TOKEN_MISSING',
  AUTH_TOKEN_EXPIRED = 'AUTH_TOKEN_EXPIRED',
  AUTH_TOKEN_INVALID = 'AUTH_TOKEN_INVALID',
  AUTH_TOKEN_MALFORMED = 'AUTH_TOKEN_MALFORMED',
  AUTH_INSUFFICIENT_PERMISSIONS = 'AUTH_INSUFFICIENT_PERMISSIONS',
  AUTH_USER_NOT_FOUND = 'AUTH_USER_NOT_FOUND',
  AUTH_ORG_NOT_FOUND = 'AUTH_ORG_NOT_FOUND',
  AUTH_ORG_NOT_ACTIVE = 'AUTH_ORG_NOT_ACTIVE',
  AUTH_EULA_ACCEPTANCE_REQUIRED = 'AUTH_EULA_ACCEPTANCE_REQUIRED',
  AUTH_UNEXPECTED_ERROR = 'AUTH_UNEXPECTED_ERROR',
}

export { ApiErrorCodes };
